"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardContainer = exports.FolderContainer = exports.FoldContentContainer = exports.FoldHoverOverlay = exports.Fold = exports.FolderBackHoverOverlay = exports.FolderBack = exports.EmptyCardHoverOverlay = exports.CardHoverOverlay = exports.CardOverlay = exports.EmptyCardOverlay = exports.BgContainer = exports.CardBg = exports.Card = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _emptyContentCard = _interopRequireDefault(require("./assets/emptyContentCard.svg"));

var _knotchincWebReactComponentsUtils = require("@bit/knotchinc.web-react-components.utils.styled-helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  padding: 8px;\n  width: 100%;\n  height: 100%;\n  -webkit-transform: translate3d(0, 0, 0);\n  cursor: pointer;\n  border-radius: 8px;\n\n  &:hover {\n    z-index: 1;\n    ", " {\n      transform: translateY(-5px) scale(1.01);\n    }\n\n    ", ", ", ", ", " {\n      opacity: 1;\n    }\n\n    ", " {\n      opacity: 0;\n    }\n  }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  padding: 8px;\n  width: ", ";\n  height: ", ";\n  transform: translate3d(0, 0, 0);\n  cursor: pointer;\n\n  &:hover {\n    z-index: 1;\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  padding: 38px 8px 30px 25px;\n  transition: all 0.6s cubic-bezier(0.25, 1.03, 0.26, 0.95);\n  height: 120px;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  padding: 38px 8px 30px 25px;\n  background: ", ";\n  transition: all 0.6s cubic-bezier(0.25, 1.03, 0.26, 0.95);\n  opacity: 0;\n  height: 120px;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  background: ", ";\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  color: white;\n  height: 120px;\n  box-shadow: -2px 2px 10px rgba(0, 0, 0, 0.3);\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n ", ";\n  background: ", ";\n  box-shadow: -0 2px 10px rgba(0, 0, 0, 0.3);\n  transition: all 0.6s cubic-bezier(0.25, 1.03, 0.26, 0.95);\n  border-radius: 10px;\n  overflow: hidden;\n  opacity: 0;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  background: ", ";\n  border-radius: 10px;\n  overflow: hidden;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 100%);\n  border-radius: 10px;\n  overflow: hidden;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", "\n  width: 100%;\n  height: 100%;\n  transition: all 0.6s cubic-bezier(0.25, 1.03, 0.26, 0.95);\n  opacity: 0;\n  border-radius: 10px;\n  overflow: hidden;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%);\n  width: 100%;\n  height: 100%;\n  border-radius: 10px;\n  overflow: hidden;\n  transition: all .3s ease;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", "\n  opacity: 0.8;\n  width: 100%;\n  height: 100%;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  border-radius: 10px;\n  overflow: hidden;\n  transform: translate3d(0, 0, 0);\n  transform-style: preserve-3d;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background-color: #ffffff;\n  background-image: url('", "');\n  background-position: center 25%;\n  background-repeat: no-repeat;\n  opacity: 0.8;\n  width: 100%;\n  height: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  border-radius: 10px;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  color: white;\n  transition: all 0.8s cubic-bezier(0.25, 1.03, 0.26, 0.95);\n  transform: translate3d(0, 0, 0);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Card = _styledComponents["default"].div(_templateObject(), (0, _knotchincWebReactComponentsUtils.absFull)());

exports.Card = Card;

var CardBg = _styledComponents["default"].div(_templateObject2(), _emptyContentCard["default"]);

exports.CardBg = CardBg;

var BgContainer = _styledComponents["default"].div(_templateObject3(), (0, _knotchincWebReactComponentsUtils.absFull)());

exports.BgContainer = BgContainer;

var EmptyCardOverlay = _styledComponents["default"].div(_templateObject4(), (0, _knotchincWebReactComponentsUtils.absFull)(), function () {
  return (0, _polished.linearGradient)({
    colorStops: ["rgba(0, 0, 0, 0.7) 0%", 'rgba(0, 0, 0, 0) 100%'],
    toDirection: '0deg',
    fallback: '#FFF'
  });
});

exports.EmptyCardOverlay = EmptyCardOverlay;

var CardOverlay = _styledComponents["default"].div(_templateObject5(), (0, _knotchincWebReactComponentsUtils.absFull)());

exports.CardOverlay = CardOverlay;

var CardHoverOverlay = _styledComponents["default"].div(_templateObject6(), (0, _knotchincWebReactComponentsUtils.absFull)(), function (props) {
  return (0, _polished.linearGradient)({
    colorStops: ["".concat(props.theme.colors.palette[4], " 0%"), (0, _polished.transparentize)(0.8, props.theme.colors.palette[5])],
    toDirection: '0deg',
    fallback: 'transparent'
  });
});

exports.CardHoverOverlay = CardHoverOverlay;
var EmptyCardHoverOverlay = (0, _styledComponents["default"])(CardHoverOverlay)(_templateObject7());
exports.EmptyCardHoverOverlay = EmptyCardHoverOverlay;

var FolderBack = _styledComponents["default"].div(_templateObject8(), (0, _knotchincWebReactComponentsUtils.absFull)('56px'), function (props) {
  return "linear-gradient(71deg, ".concat(props.theme.colors.palette[0], " 0%, ").concat(props.theme.colors.palette[3], " 100%)");
});

exports.FolderBack = FolderBack;

var FolderBackHoverOverlay = _styledComponents["default"].div(_templateObject9(), (0, _knotchincWebReactComponentsUtils.absFull)('56px'), function (props) {
  return "linear-gradient(71deg, ".concat(props.theme.colors.palette[1], " 0%, ").concat(props.theme.colors.palette[3], " 100%)");
});

exports.FolderBackHoverOverlay = FolderBackHoverOverlay;

var Fold = _styledComponents["default"].div(_templateObject10(), (0, _knotchincWebReactComponentsUtils.absFull)('auto'), function (props) {
  return "linear-gradient(71deg, ".concat(props.theme.colors.palette[1], " 0%, ").concat(props.theme.colors.palette[4], " 100%)");
});

exports.Fold = Fold;

var FoldHoverOverlay = _styledComponents["default"].div(_templateObject11(), (0, _knotchincWebReactComponentsUtils.absFull)('auto'), function (props) {
  return "linear-gradient(71deg, ".concat(props.theme.colors.palette[3], " 0%, ").concat(props.theme.colors.palette[4], " 100%)");
});

exports.FoldHoverOverlay = FoldHoverOverlay;

var FoldContentContainer = _styledComponents["default"].div(_templateObject12(), (0, _knotchincWebReactComponentsUtils.absFull)('auto'));

exports.FoldContentContainer = FoldContentContainer;

var FolderContainer = _styledComponents["default"].div(_templateObject13(), function (props) {
  return props.width || '300px';
}, function (props) {
  return props.height || '380px';
});

exports.FolderContainer = FolderContainer;

var CardContainer = _styledComponents["default"].div(_templateObject14(), Card, CardHoverOverlay, FolderBackHoverOverlay, FoldHoverOverlay, CardOverlay);

exports.CardContainer = CardContainer;

//# sourceMappingURL=styled.js.map